import React from "react"
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import strings from "../../../localization/strings"
import AccountStore from "../../../stores/AccountStore"
import { EPunchSetApprovalType, IPayrollPunchSet } from "../../../models"
import ApproveIcon from "../../../components/approve/ApproveIcon"
import ShiftNoteTooltip from "../../../components/schedule/ShiftNoteTooltip"
import * as timeHelper from "../../../helpers/timeHelper"
import moment from "moment"

interface IProps {
	payrollPunchSets: IPayrollPunchSet[]
}

const PayrollTimeByHierarchyEmployeeDayPunchSetRow: React.SFC<IProps> = (props: IProps) => {
	if (props.payrollPunchSets.length == 0) return null;
	var formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	});

	return (
		<Table style={{ backgroundColor: "none" }} selectable={false}>
			<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
				<TableRow>
					<TableHeaderColumn className="TextOverflow" title={strings.In} style={styles.inCol}>{strings.In}</TableHeaderColumn>
					<TableHeaderColumn className="TextOverflow" title={strings.Out} style={styles.outCol}>{strings.Out}</TableHeaderColumn>
					{AccountStore.getShowPayrollRates() &&
						<TableHeaderColumn className="TextOverflow" title={`${strings.Pay} ${strings.Amount}`} style={styles.outCol}>{strings.Pay} {strings.Amount}</TableHeaderColumn>
					}
					{AccountStore.getEmployeeApproveTimecardEnabled() &&
						<TableHeaderColumn className="TextOverflow" title={strings.Employee} style={styles.approvedCol}>{strings.Employee}</TableHeaderColumn>
					}
					<TableHeaderColumn className="TextOverflow" title={strings.Supervisor} style={styles.approvedCol}>{strings.Supervisor}</TableHeaderColumn>
					{AccountStore.getExtSupApproveTimecardEnabled() &&
						<TableHeaderColumn className="TextOverflow" title={strings.External} style={styles.approvedCol}>{strings.External}</TableHeaderColumn>
					}
					<TableHeaderColumn className="TextOverflow" title={strings.Pay_Type} style={styles.approvedCol}>{strings.Pay_Type}</TableHeaderColumn>
					{AccountStore.getScheduleEnabled() &&
						<TableHeaderColumn className="TextOverflow" title={strings.Shift_Note} style={styles.approvedCol}>{strings.Shift_Note}</TableHeaderColumn>
					}
				</TableRow>
			</TableHeader>
			<TableBody displayRowCheckbox={false}>
				{props.payrollPunchSets.map((punchSet, index) => {
					const payTypeObjList = AccountStore.getCurrentAccount().PayTypes.filter(ptt => ptt.Id === punchSet.PayTypeId)
					const payTypeLabel = payTypeObjList && payTypeObjList.length > 0 ? payTypeObjList[0].Name : ""
					return (
						<TableRow key={index}>
							<TableRowColumn style={styles.inCol}>
								{punchSet.PunchInTime !== "0001-01-01T00:00:00Z" && moment(timeHelper.keepConvertUTCToLocal(punchSet.PunchInTimeLocal)).format("hh:mma")}
							</TableRowColumn>
							<TableRowColumn style={styles.outCol}>
								{punchSet.PunchOutTime !== "0001-01-01T00:00:00Z" && moment(timeHelper.keepConvertUTCToLocal(punchSet.PunchOutTimeLocal)).format("hh:mma")}
							</TableRowColumn>
							{AccountStore.getShowPayrollRates() &&
								<TableRowColumn style={styles.outCol}>{formatter.format(punchSet.PayTotal)}</TableRowColumn>
							}
							{AccountStore.getEmployeeApproveTimecardEnabled() &&
								<TableRowColumn style={styles.approvedCol}>
									<ApproveIcon
										identify={`DayPunchSetRowEmpApprove${index}`}
										toolTipPosition="bottom"
										toolTipArrow="center"
										approvalType={EPunchSetApprovalType.Employee}
										width={14}
										punchSets={[punchSet]}
										expenses={[]}
									/>
								</TableRowColumn>
							}
							<TableRowColumn style={styles.approvedCol}>
								<ApproveIcon
									identify={`DayPunchSetRowApprove${index}`}
									toolTipPosition="bottom"
									toolTipArrow="center"
									approvalType={EPunchSetApprovalType.Supervisor}
									width={18}
									punchSets={[punchSet]}
									expenses={[]}
								/>
							</TableRowColumn>
							{AccountStore.getExtSupApproveTimecardEnabled() &&
								<TableRowColumn style={styles.approvedCol}>
									<ApproveIcon
										identify={`DayPunchSetRowExtSupApprove${index}`}
										toolTipPosition="bottom"
										toolTipArrow="center"
										approvalType={EPunchSetApprovalType.ExtSupervisor}
										width={14}
										punchSets={[punchSet]}
										expenses={[]}
									/>
								</TableRowColumn>
							}
							<TableRowColumn style={styles.approvedCol}>
								{payTypeLabel}
							</TableRowColumn>
							{AccountStore.getScheduleEnabled() &&
								<TableRowColumn style={styles.approvedCol}>
									{punchSet.ShiftId && !punchSet.BreakId &&
										<ShiftNoteTooltip
											shiftId={punchSet.ShiftId}
										/>
									}
								</TableRowColumn>
							}
						</TableRow>
					)
				})}
			</TableBody>
		</Table>
	)
}

export default PayrollTimeByHierarchyEmployeeDayPunchSetRow

const styles = {
	inCol: {
		paddingLeft: 0,
		paddingRight: 10,
		width: 75
	},
	outCol: {
		paddingLeft: 10,
		paddingRight: 0,
		width: 75
	},
	approvedCol: {
		width: 75,
		textAlign: "center"
	}
}
